import React, { useEffect, useRef, useState } from 'react'
import styles from './input.module.scss'
import cx from 'classnames'
import EyeIcon from '../../../icons/eye.svg'
import EyeShowIcon from '../../../icons/showEye.svg'
import EditIcon from '../../../icons/edit.svg'
import ErrorIcon from '../../../icons/errorIcon.svg'
import Calendar from 'react-calendar'
import CloseIcon from '../../../icons/closeIcon.svg'
import RightArrow from '../../../icons/rightArrowIcon.svg'
import LeftArrow from '../../../icons/leftArrowIcon.svg'
import moment from 'moment/moment'
import { useSelector } from 'react-redux'

const Input = ({
  placeholder,
  marginBottom,
  type,
  showEye,
  tip,
  calendar,
  autoFocus,
  validationMessage,
  required,
  readOnly,
  promoCodeApplied,
  handleApplyOrEditPromoCode,
  values,
  setValues,
  calendarIcon,
  calendarValue,
  hideCloseIcon,
  onChangeCalendar,
  minDate,
  maxDate,
  defaultActiveStartDate,
  edit,
  onEditClick,
  passwordEdit,
  ...props
}) => {
  const [typeState, setTypeState] = useState(type || 'text')
  const [showIcon, setShowIcon] = useState(false)
  const inputRef = useRef(null)
  const [openCalendar, setOpenCalendar] = useState(false)
  const { selectedLanguage } = useSelector((state) => state.metadata)

  const onEyeClick = () => {
    if (typeState === 'password') {
      setTypeState('text')
      setShowIcon(true)
    } else {
      setTypeState('password')
      setShowIcon(false)
    }
  }

  useEffect(() => {
    if (autoFocus) {
      inputRef.current.focus()
    }
  }, [autoFocus])

  useEffect(() => {
    if (typeState === 'text' && type === 'password') {
      setTypeState(type)
      setShowIcon(false)
    }
  }, [passwordEdit])
  const openCalendars = () => {
    if (!openCalendar) {
      setOpenCalendar(true)
    } else setOpenCalendar(false)
  }

  const emptyInputValue = () => {
    onChangeCalendar('')
  }
  const handleChangeCalendar = (date) => {
    setOpenCalendar(false)
    onChangeCalendar(date)
  }
  return (
    <div
      className={cx(styles.inputWrapper, {
        [styles.marginBottom]: marginBottom,
      })}
    >
      <input
        className={cx(styles.inputText, {
          [styles.invalidInput]: validationMessage,
          [styles.readOnly]: readOnly,
        })}
        type={typeState}
        {...props}
        required
        ref={inputRef}
      />
      <span
        className={cx(styles['floating-label'], {
          [styles.floatingLabelRequired]: required,
        })}
      >
        {placeholder}
      </span>
      {edit ? <img src={EditIcon} alt={'Edit'} onClick={onEditClick} /> : []}
      {showEye ? (
        <img
          src={showIcon ? EyeShowIcon : EyeIcon}
          alt={'Eye'}
          onClick={onEyeClick}
        />
      ) : (
        []
      )}
      {calendar && (
        <>
          {<img src={calendarIcon} alt={'CalendarIcon'} onClick={openCalendars} />}
          {!!openCalendar && (
            <Calendar
              onClickDay={handleChangeCalendar}
              onChange={handleChangeCalendar}
              className={styles.reactCalendar}
              nextLabel={<img src={RightArrow} alt={'next'} />}
              prevLabel={<img src={LeftArrow} alt={'Previous'} />}
              next2Label={null}
              prev2Label={null}
              value={new Date(calendarValue)}
              defaultActiveStartDate={defaultActiveStartDate}
              maxDate={maxDate}
              minDate={minDate}
              locale={moment.locale(selectedLanguage)}
            />
          )}
        </>
      )}
      {validationMessage ? (
        <div
          className={cx(styles.errorMessage, {
            [styles.worstPromoCode]: promoCodeApplied,
          })}
        >
          <img src={ErrorIcon} alt={ErrorIcon} />
          <span>{validationMessage}</span>
        </div>
      ) : null}
    </div>
  )
}

export default Input
